import { render } from "./UserAuth.vue?vue&type=template&id=735e93be&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=735e93be&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735e93be"]])

export default __exports__